<template lang="pug">
el-dialog.modal-justificativa-restricoes(
    :visible.sync='mostrarDialog',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :show-close='false',
    width='500px'
)
    div(
        style='background: white; height: auto; padding: 20px; border-radius: 5px'
    )
        section.mb-4.template(slot='title')
            .modal-justificativa-restricoes__header
                .modal-justificativa-restricoes__header--title
                    | Restrições inibidas

        section.mb-4.template(slot='body')
            .modal-justificativa-restricoes__body
                p.modal-justificativa-restricoes__body--title
                    | Operação:
                    | {{ dadosInibicao.operacaoSelecionada.operacao.identificador }}
                p.modal-justificativa-restricoes__body--value
                    | Nome:
                    | {{ dadosInibicao.operacaoSelecionada.operacao.nome }}
                p.modal-justificativa-restricoes__body--value
                    | Justificativa:
                    | {{ dadosInibicao.operacaoSelecionada.justificativa }}
                p.modal-justificativa-restricoes__body--value
                    | Descrição:
                    | {{ dadosInibicao.operacaoSelecionada.descricaoJustificativa }}
                p.modal-justificativa-restricoes__body--value
                    | Data da inibição:
                    | {{ dadosInibicao.operacaoSelecionada.data }}
                p.modal-justificativa-restricoes__body--value
                    | Usuário:
                    | {{ dadosInibicao.operacaoSelecionada.nomeUsuario }}
                div(v-if='dadosInibicao.outrasOperacoes')
                    hr
                    p.modal-justificativa-restricoes__body--title
                        | Outras operações com restrição inibida
                    div(
                        v-for='(inibicao, index) in dadosInibicao.outrasOperacoes'
                    )
                        hr(v-if='index > 0')
                        p.modal-justificativa-restricoes__body--value
                            | Identificador:
                            | {{ inibicao.operacao.identificador }}
                        p.modal-justificativa-restricoes__body--value
                            | Nome:
                            | {{ inibicao.operacao.nome }}
                        p.modal-justificativa-restricoes__body--value
                            | Justificativa:
                            | {{ inibicao.justificativa }}
                        p.modal-justificativa-restricoes__body--value
                            | Descrição:
                            | {{ inibicao.descricaoJustificativa }}
                        p.modal-justificativa-restricoes__body--value
                            | Data da inibição:
                            | {{ inibicao.data }}
                        p.modal-justificativa-restricoes__body--value
                            | Usuário:
                            | {{ inibicao.nomeUsuario }}

        section.modal-justificativa-restricoes__action
            el-button(type='primary', size='mini', @click='fechar')
                | Voltar
</template>

<script>
import OperacaoMonitoramentoService from '@/services/OperacaoMonitoramentoService';

export default {
    name: 'ModalJustificativaRestricoes',

    props: {
        idOperacao: {
            required: true
        },
        codigoRestricao: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            mostrarDialog: false,
            dadosInibicao: {}
        };
    },

    watch: {
        mostrarDialog: function (value) {
            if (value) {
                this.buscarInibicao();
            }
        }
    },

    methods: {
        async buscarInibicao() {
            await OperacaoMonitoramentoService.buscarInibicaoRestricaoOperacao({
                idOperacao: this.idOperacao,
                codigoRestricao: this.codigoRestricao
            })
                .then(({ data }) => {
                    this.dadosInibicao = data;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar a inibição da restrição.'
                    })
                );
        },
        fechar() {
            this.mostrarDialog = false;
        }
    }
};
</script>

<style lang="scss">
.modal-justificativa-restricoes {
    display: flex;

    .modal-justificativa-restricoes__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .modal-justificativa-restricoes__header--title {
            font-size: 16px;
            font-weight: 600;
            word-wrap: break-word;
        }
    }

    .modal-justificativa-restricoes__body {
        width: 100%;
        overflow-y: scroll;
        height: 270px;

        .modal-justificativa-restricoes__body--title {
            font-weight: 600;
            font-size: 14px;
        }

        .modal-justificativa-restricoes__body--value {
            font-weight: 500;
            font-size: 14px;
            word-wrap: break-word;
        }
    }

    .modal-justificativa-restricoes__action {
        height: 50px;
        border-top: solid 2px #e7e7e7;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    }

    .el-dialog {
        background: none !important;
    }

    .el-dialog__body {
        padding: 20px;
    }
}
</style>
